// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b06327f3","239":"1c950ad6","243":"541a53b7","396":"5bb78fd8","450":"572ba5e6","455":"8478ded7","857":"3245cf0b","884":"13cdf1ec","942":"f959b980","977":"56326a58"}[chunkId] + ".chunk.js";
};